import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
const SettingsWrapper = () => import('../SettingsWrapper.vue');
const IntegrationHooks = () => import('./IntegrationHooks.vue');
const Index = () => import('./Index.vue');
const Browse = () => import('./Browse.vue');
const Webhook = () => import('./Webhooks/Index.vue');
const DashboardApps = () => import('./DashboardApps/Index.vue');
const Slack = () => import('./Slack.vue');
const Linear = () => import('./Linear.vue');
const Notion = () => import('./Notion.vue');
const Shopify = () => import('./Shopify.vue');
const CommerceProviderSettings = () => import('./CommerceProviderSettings.vue');
const MetaBusinessAccounts = () => import('./MetaBusinessAccounts.vue');
const PaidAds = () => import('./PaidAds.vue');
const GoogleCalendar = () => import('./GoogleCalendar.vue');
const GoogleSheets = () => import('./GoogleSheets.vue');
const DeveloperApi = () => import('./DeveloperApi.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/integrations'),
      component: SettingsWrapper,
      props: {},
      children: [
        {
          path: 'odoo',
          name: 'settings_integrations_odoo',
          component: () => import('./Odoo.vue'),
          meta: {
            featureFlag: 'odoo_integration',
            permissions: ['administrator'],
          },
        },
        {
          path: '',
          name: 'settings_applications',
          component: Index,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'browse',
          name: 'settings_integrations_browse',
          component: Browse,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'dashboard_apps',
          component: DashboardApps,
          name: 'settings_integrations_dashboard_apps',
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'webhook',
          component: Webhook,
          name: 'settings_integrations_webhook',
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/integrations'),
      component: SettingsWrapper,
      children: [
        {
          path: 'developer-api',
          name: 'settings_integrations_developer_api',
          component: DeveloperApi,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'slack',
          name: 'settings_integrations_slack',
          component: Slack,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
          props: route => ({ code: route.query.code }),
        },
        {
          path: 'linear',
          name: 'settings_integrations_linear',
          component: Linear,
          meta: {
            permissions: ['administrator'],
          },
          props: route => ({ code: route.query.code }),
        },
        {
          path: 'notion',
          name: 'settings_integrations_notion',
          component: Notion,
          meta: {
            permissions: ['administrator'],
          },
          props: route => ({ code: route.query.code }),
        },
        {
          path: 'shopify',
          name: 'settings_integrations_shopify',
          component: Shopify,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
          props: route => ({ error: route.query.error }),
        },
        {
          path: 'easyorders',
          name: 'settings_integrations_easyorders',
          component: CommerceProviderSettings,
          props: {
            provider: 'easyorders',
            featureName: FEATURE_FLAGS.EASYORDERS,
          },
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'salla',
          name: 'settings_integrations_salla',
          component: CommerceProviderSettings,
          props: { provider: 'salla', featureName: FEATURE_FLAGS.SALLA },
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'zid',
          name: 'settings_integrations_zid',
          component: CommerceProviderSettings,
          props: { provider: 'zid', featureName: FEATURE_FLAGS.ZID },
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'meta-business-accounts',
          name: 'settings_integrations_meta_business_accounts',
          component: MetaBusinessAccounts,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'paid-ads',
          name: 'settings_integrations_paid_ads',
          component: PaidAds,
          meta: {
            featureFlag: FEATURE_FLAGS.PAID_ADS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'meta-ads',
          name: 'settings_integrations_meta_ads',
          redirect: to => ({
            name: 'settings_integrations_meta_business_accounts',
            params: to.params,
            query: { ...to.query, section: 'ads' },
            hash: to.hash,
          }),
          meta: {
            featureFlag: FEATURE_FLAGS.META_ADS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'tiktok-ads',
          name: 'settings_integrations_tiktok_ads',
          component: PaidAds,
          props: { provider: 'tiktok' },
          meta: {
            featureFlag: FEATURE_FLAGS.TIKTOK_ADS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'google-ads',
          name: 'settings_integrations_google_ads',
          component: PaidAds,
          props: { provider: 'google' },
          meta: {
            featureFlag: FEATURE_FLAGS.GOOGLE_ADS,
            permissions: ['administrator'],
          },
        },
        {
          path: 'google-calendar',
          name: 'settings_integrations_google_calendar',
          component: GoogleCalendar,
          meta: {
            featureFlag: FEATURE_FLAGS.WORKSPACE_CALENDAR,
            permissions: ['administrator', 'agent', 'custom_role'],
          },
        },
        {
          path: 'google-sheets',
          name: 'settings_integrations_google_sheets',
          component: GoogleSheets,
          meta: {
            featureFlag: FEATURE_FLAGS.GOOGLE_SHEETS,
            permissions: ['administrator'],
          },
        },
        {
          path: ':integration_id',
          name: 'settings_applications_integration',
          component: IntegrationHooks,
          meta: {
            featureFlag: FEATURE_FLAGS.INTEGRATIONS,
            permissions: ['administrator'],
          },
          props: route => ({
            integrationId: route.params.integration_id,
          }),
        },
      ],
    },
  ],
};
